var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconfinder_2018_social_media_popular_app_logo_instagram_3225191",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#ffd020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#fec01e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fca71b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#fa8316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#f85510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#f51e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f30005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#f20007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#e1003b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#d30067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#c70088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#bf00a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#bb00af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b900b4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M19,38h0A19,19,0,0,1,0,19H0A19,19,0,0,1,19,0h0A19,19,0,0,1,38,19h0A19,19,0,0,1,19,38Z",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(6.027 6.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M171.573,161.037c3.462,0,3.872.011,5.24.076a7.116,7.116,0,0,1,2.409.448,4.289,4.289,0,0,1,2.459,2.459,7.214,7.214,0,0,1,.448,2.409c.061,1.368.076,1.778.076,5.24s-.011,3.872-.076,5.24a7.116,7.116,0,0,1-.448,2.409,4.289,4.289,0,0,1-2.459,2.459,7.214,7.214,0,0,1-2.409.448c-1.368.061-1.778.076-5.24.076s-3.872-.011-5.24-.076a7.116,7.116,0,0,1-2.409-.448,4.289,4.289,0,0,1-2.459-2.459,7.214,7.214,0,0,1-.448-2.409c-.061-1.368-.076-1.778-.076-5.24s.011-3.872.076-5.24a7.116,7.116,0,0,1,.448-2.409,4.289,4.289,0,0,1,2.459-2.459,7.215,7.215,0,0,1,2.409-.448c1.368-.065,1.778-.076,5.24-.076m0-2.337c-3.523,0-3.963.015-5.347.08a9.533,9.533,0,0,0-3.15.6,6.261,6.261,0,0,0-2.3,1.493,6.384,6.384,0,0,0-1.5,2.3,9.59,9.59,0,0,0-.6,3.15c-.065,1.383-.08,1.824-.08,5.347s.015,3.963.08,5.347a9.534,9.534,0,0,0,.6,3.15,6.654,6.654,0,0,0,3.8,3.789,9.59,9.59,0,0,0,3.15.6c1.383.065,1.824.08,5.347.08s3.963-.015,5.347-.08a9.534,9.534,0,0,0,3.15-.6,6.654,6.654,0,0,0,3.789-3.8,9.589,9.589,0,0,0,.6-3.15c.065-1.383.08-1.824.08-5.347s-.015-3.963-.08-5.347a9.533,9.533,0,0,0-.6-3.15,6.654,6.654,0,0,0-3.8-3.789,9.59,9.59,0,0,0-3.15-.6c-1.379-.061-1.82-.076-5.343-.076Z",
    transform: "translate(-158.6 -158.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M331.361,324.7a6.661,6.661,0,1,0,6.661,6.661A6.662,6.662,0,0,0,331.361,324.7Zm0,10.986a4.324,4.324,0,1,1,4.324-4.324A4.324,4.324,0,0,1,331.361,335.686Z",
    transform: "translate(-318.388 -318.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_277",
    "data-name": "Ellipse 277",
    cx: 1.558,
    cy: 1.558,
    r: 1.558,
    transform: "translate(18.339 4.488)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFooter);
export default __webpack_public_path__ + "static/media/instagramFooter.64e5d55d8d154165141f196acd48faff.svg";
export { ForwardRef as ReactComponent };